module.exports = __webpack_public_path__ + "img/601.dbf3357b.jpg";